import {
  Button,
  Code,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
  VStack,
  useClipboard,
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IssuedInternalApiKey } from '@texas/api/endpoints/internalApiKeysApi';

export function IssuedInternalApiKeyModal({
  apiKey,
  isOpen,
  onClose,
}: {
  apiKey: IssuedInternalApiKey;
  isOpen: boolean;
  onClose: () => void;
}) {
  const { t } = useTranslation();
  const { onCopy, hasCopied } = useClipboard(apiKey.apiKey);

  return (
    <Modal
      variant="entityDirectory"
      isOpen={isOpen}
      onClose={onClose}
      closeOnOverlayClick={false}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t('internalApiKeys.generated')}</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text>{t('internalApiKeys.copyWarning')}</Text>
            <Code p={3} whiteSpace="normal" wordBreak="break-all">
              {apiKey.apiKey}
            </Code>
          </VStack>
        </ModalBody>
        <ModalFooter gap={2}>
          <Button variant="entityDirectorySecondary" onClick={onClose}>
            {t('general.close')}
          </Button>
          <Button variant="entityDirectoryPrimary" onClick={onCopy}>
            {hasCopied
              ? t('internalApiKeys.copied')
              : t('internalApiKeys.copy')}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}
